import { useEffect, useState } from "react";
import { useAccount, useWalletClient } from "wagmi";
import { Button } from "@/src/components";
import { shortenAddress } from "@/src/lib/address";
import { activeChain } from "@/src/configs/chainConfig";
import { switchNetwork } from "@/src/lib/utils";
import { useWeb3Modal } from "@web3modal/wagmi/react";

export const ConnectButton = () => {
  const { open } = useWeb3Modal();
  const { address, isConnected } = useAccount();
  const { chain } = useAccount();
  const { data: walletProvider } = useWalletClient();

  const [{ isCorrectChain }, setState] = useState({
    isCorrectChain: true,
  });

  useEffect(() => {
    if (isConnected)
      setState({
        isCorrectChain: chain?.id === Number(activeChain.chainId),
      });

  }, [chain, isConnected]);

  const onChainChanged = async () => {
    try {
      await switchNetwork(walletProvider, activeChain);
    } catch (err) {}
  };

  return (
    <>
      {isCorrectChain && (
        <Button
          type="button"
          onClick={() => open()}
          className="max-w-[180px] sm:max-w-[220px] bg-secondary border border-border text-foreground hover:bg-muted hover:border-primary/40 hover:shadow-glow text-[10px] sm:text-xs"
        >
          {shortenAddress(address) || "Connect Wallet"}
        </Button>

      )}

      {!isCorrectChain && (
        <Button
          type="button"
          onClick={onChainChanged}
          className="max-w-[180px] sm:max-w-[220px] bg-destructive/20 border border-destructive/50 text-destructive hover:bg-destructive/30 text-[10px] sm:text-xs"
        >
          Wrong Network
        </Button>
      )}
    </>
  );
};
